    // license: 'B439F-20I52-CCKJK-S8QRZ',
    import React from 'react';
    import JoditEditor from 'jodit-pro-react';

    const JoditEditorWrapper = ({ value, onBlur, onChange }) => {
      const config = {
        readonly: false,
        height: 250,
        toolbarSticky: false,
        toolbarButtonSize: 'large',
        showCharsCounter: false,
        showWordsCounter: false,
        showXPathInStatusbar: false,
        license: process.env.JODIT_KEY,
        toolbarAdaptive: false,
        allowResizeX: true,
        enter: 'DIV',
        placeholder: 'Start typing...',
        buttons: [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'font',
          'fontsize',
          'brush',
          'background',
          'paragraph',
          '|',
          'align',
          'outdent',
          'indent',
          '|',
          'ul',
          'ol',
          'hr',
          'paragraph',
          'table',
          'symbols',
          '|',
          'link',
          'unlink',
          '|',
          'cut',
          'copy',
          'file',
          'paste',
          'selectall',
          'eraser',
          'undo',
          'redo',
          '|',
        ],
        controls: {
          background: {
            list: {
              '': 'None',
              '#ffffff': 'White',
              '#f8f9fa': 'Light Gray',
              '#000000': 'Black',
              '#ffff00': 'Yellow',
              '#00ffff': 'Cyan',
            },
          },
        },
      };

      return (
        <JoditEditor
          value={value}
          config={config}
          onBlur={onChange}
        />
      );
    };

    export default JoditEditorWrapper;
